import { MenuConfigItem } from 'components/common/SideMenu/SideMenu';

type DashboardConfigKey = 'planning' | 'execution' | 'risk' | 'reporting' | 'portfolio';

export const dashboardConfig: Record<DashboardConfigKey, MenuConfigItem> = {
    planning: {
        name: 'Planning',
        title: 'Planning',
        link: 'planning',
    },
    execution: {
        name: 'Execution',
        title: 'Execution',
        link: 'execution',
    },
    risk: {
        name: 'Risk',
        title: 'Risk',
        link: 'risk',
    },
    reporting: {
        name: 'Reporting',
        title: 'Reporting',
        link: 'reporting',
    },
    portfolio: {
        name: 'Portfolio',
        title: 'Portfolio',
        link: 'portfolio',
    },
};
